'use strict';

((win, doc) => {
    const deskWide = win.matchMedia("(min-width: 1360px)");
    if (!deskWide.matches) return;

    const opts = Object.assign({},
        doc.body.dataset.sicScroll || {},
        {klass: 'scroll', scroll: 100}
    );

    win.addEventListener("scroll", function onScroll(e) {
        doc.body.classList.toggle(opts.klass, win.scrollY >= opts.scroll);
    });
})(window, document);
